import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Mock {
  id: string
  title: string
  description?: string
  brand_id?: string
  conversation_json: any
  ios_version: 'ios18' | 'ios26'
  status: 'draft' | 'published' | 'archived'
  vertical?: string
  use_case?: string
  tags?: string[]
  output_gif_url?: string
  created_at: string
  updated_at: string
}

interface MocksState {
  mocks: Mock[]
  selectedMock: Mock | null
  isLoading: boolean
  filters: {
    status?: string
    vertical?: string
    brand_id?: string
  }
}

const initialState: MocksState = {
  mocks: [],
  selectedMock: null,
  isLoading: false,
  filters: {},
}

const mocksSlice = createSlice({
  name: 'mocks',
  initialState,
  reducers: {
    setMocks: (state, action: PayloadAction<Mock[]>) => {
      state.mocks = action.payload
    },
    setSelectedMock: (state, action: PayloadAction<Mock | null>) => {
      state.selectedMock = action.payload
    },
    addMock: (state, action: PayloadAction<Mock>) => {
      state.mocks.unshift(action.payload)
    },
    updateMock: (state, action: PayloadAction<Mock>) => {
      const index = state.mocks.findIndex(m => m.id === action.payload.id)
      if (index !== -1) {
        state.mocks[index] = action.payload
      }
      if (state.selectedMock?.id === action.payload.id) {
        state.selectedMock = action.payload
      }
    },
    removeMock: (state, action: PayloadAction<string>) => {
      state.mocks = state.mocks.filter(m => m.id !== action.payload)
    },
    setFilters: (state, action: PayloadAction<MocksState['filters']>) => {
      state.filters = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export const { setMocks, setSelectedMock, addMock, updateMock, removeMock, setFilters, setLoading } = mocksSlice.actions
export default mocksSlice.reducer

